import {LOG_TYPES} from '@/constants/logTypes';

export default {
  namespaced: true,
  state: {
    tableLoading: false,
    filterParams: {},
    emailTypeList: [],
    smsTypeList: [],
    eboksTypeList: [],
    logType: LOG_TYPES.EBOKS
  },
  mutations: {
    updateTableLoading(state, payload) {
      state.tableLoading = payload;
    },
    updateFilterParams(state, payload) {
      state.filterParams = payload;
    },
    updateEmailTypeList(state, payload) {
      state.emailTypeList = payload;
    },
    updateLogType(state, payload) {
      state.logType = payload;
    },
    updateSmsTypeList(state, payload) {
      state.smsTypeList = payload;
    },
    updateEboksTypeList(state, payload) {
      state.eboksTypeList = payload;
    },
  },
};
